<div class="form-check">
  <input class="form-check-input" type="checkbox" [(ngModel)]="isChecked" (change)="checkValue($event)" id="newsletterCheckbox" />
  <label class="form-check-label" for="newsletterCheckbox">
    <span i18n="@@CheckNewsletterCheckboxLabel">Subscribe to newsletter</span>
  </label>
</div>
